import apiFactory from '@/api/default';
const API = apiFactory('detections');

const state = {
  detectionSearchResults: [],
  currentDetection: {},

};

const getters = {
  detectionSearchResults: (state) => state.detectionSearchResults,
  currentDetection: (state) => state.currentDetection,
};

const mutations = {
  setDetectionSearchResults: (state, detectionSearchResults) => {
    // state.detectionSearchResults = [];
    state.detectionSearchResults = detectionSearchResults;
    console.log(detectionSearchResults);
  },
  removeFromDetectionSearchResults: (state, id) => {
    state.detectionSearchResults.data = state.detectionSearchResults.filter((obj) => {
      return obj._id !== id;
    });
    state.detectionSearchResults.total--;
  },
  setCurrentDetection: (state, currentDetection) => {
    state.currentDetection = currentDetection;
  },
  setCurrentDetectionProperty: (state, data) => {
    state.currentDetection[data.prop] = data.value;
  },

};

const actions = {
  async searchDetections({commit}, data) {
    const response = await API.search(data.query);
    if (response) {
      if (data.opts?.setResultsInStore) {
        commit('setDetectionSearchResults', response.data);
      }
      return response.data;
    }
  },
  async loadDetection({commit}, data) {
    const response = await API.load(data.id, data.query);
    if (response) {
      commit('setSelectedDetection', response.data);
      return response.data;
    }
  },
  async createDetection({commit}, data) {
    const response = await API.create(data);
    return response.data;
  },
  async updateDetection(store, payload) {
    const response = await API.update(payload.id, payload.data);
    return response.data;
  },
  async deleteDetection({commit}, id) {
    const response = await API.remove(id);
    commit('removeFromSearchResults', id);
    return response;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
